import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useForm } from "react-hook-form";
import { Company } from '../../components/companies/company.model'
import { User } from '../../components/users/user.model';
import { FormHelperText, FormControl, Box } from '@material-ui/core';
import { userService } from '../../_services/user.service'
import { companyService } from '../../_services/company.service';
import { useHistory } from 'react-router-dom';
import useSnackBars from '../../components/commons/snackbar/SnackbarHook';
import { useErrorHandler } from '../../components/errors/ErrorBoundary';
import { Link as RouterLink } from 'react-router-dom';
import { useSubdomain } from '../../components/commons/subdomain/SubdomainHook';
import useFormsPublicStyles from '../public-pages/useFormsPublicStyles';

export interface RegisterData {
  company: Company
  firstname: string
  lastname: string
  email: string
  password?: string
  passwordMatch?: string
}

const UserRegisterForm: React.FC = () => {
  const classes = useFormsPublicStyles();
  const [companies, setCompanies] = React.useState<Company[]>([]);
  const [password, setPassword] = React.useState();
  const history = useHistory()
  const handleError = useErrorHandler();
  const { company } = useSubdomain();
  const { register, handleSubmit, setError, errors } = useForm<RegisterData>({
    defaultValues: {
      company: companies && companies.length ? companies[0] : '' as any,
    }
  });
  const { showSuccess, showError } = useSnackBars();

  const onSubmit = (data: RegisterData) => {
    create(data)
  }

  const handleApiError = (errors: any) => {
    Object.keys(errors).forEach((field) => {
      const e = errors[field]
      e.param === 'api' ? showError(e.msg) : setError(e.param, { type: e.param, message: e.msg })
    })
  }

  useEffect(() => {
    const fetchData = async () => {
      var companies = await companyService.list()
      setCompanies(companies)
    }
    fetchData();
  }, [])

  const create = async (data: RegisterData) => {
    try {
      const user: User = {
        company: company,
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        password: data.password
      }
      const res = await userService.register(user)
      showSuccess(res.msg)
      history.push("/login")
    } catch (error) {
      error instanceof Error ?
        handleError(error) :
        handleApiError(error.errors)
    }
  }

  const handlePassword = (e: any) => {
    setPassword(e.target.value)
  }

  return (
    <Box height='100%' display="flex" flexDirection="column">
      <Box className={classes.imageContainer}>
        <img src={"/logo-negativo.png"} alt="logo de webee" />
      </Box>
      <Box className={classes.mainContainer}>
        <Grid container justifyContent="center" alignContent="center">
          <Grid item xs={12} md={9}>
            <Box className={classes.title}>
              <Typography>Registro de usuario</Typography>
            </Box>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TextField
                className={classes.textField}
                variant="filled"
                error={errors.firstname ? true : false}
                margin="normal"
                size="small"
                fullWidth
                id="firstname"
                label="Nombre"
                name="firstname"
                autoComplete="firstname"
                autoFocus
                inputRef={register({ required: { value: true, message: "El nombre es obligatorio" } })}
              />
              <FormHelperText error={true} className={classes.formHelperText}>
                {errors?.firstname && errors.firstname.message}
              </FormHelperText>
              <TextField
                className={classes.textField}
                variant="filled"
                error={errors.lastname ? true : false}
                margin="normal"
                size="small"
                fullWidth
                name="lastname"
                label="Apellido"
                id="lastname"
                autoComplete="lastname"
                inputRef={register({ required: { value: true, message: "El apellido es obligatorio" } })}
              />
              <FormHelperText error={true} className={classes.formHelperText}>
                {errors?.lastname && errors.lastname.message}
              </FormHelperText>
              <TextField
                className={classes.textField}
                variant="filled"
                error={errors.email ? true : false}
                margin="normal"
                size="small"
                fullWidth
                name="email"
                label="Correo electrónico"
                id="email"
                autoComplete="email"
                inputRef={register({ required: { value: true, message: "El email es obligatorio" }, pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Debe ingresar un email válido" } })}
              />
              <FormHelperText error={true} className={classes.formHelperText}>
                {errors?.email && errors.email?.message}
              </FormHelperText>
              <TextField
                className={classes.textField}
                variant="filled"
                margin="normal"
                size="small"
                error={errors.password ? true : false}
                fullWidth
                type="password"
                name="password"
                label="Contraseña"
                id="password"
                autoComplete="current-password"
                onChange={handlePassword}
                inputRef={register({ required: { value: true, message: "La contraseña es obligatoria" } })}
              />
              <FormHelperText error={true} className={classes.formHelperText}>
                {errors?.password && errors.password.message}
              </FormHelperText>
              <TextField
                className={classes.textField}
                variant="filled"
                margin="normal"
                size="small"
                error={(errors.passwordMatch ? true : false)}
                fullWidth
                type="password"
                name="passwordMatch"
                label="Repetir Contraseña"
                id="passwordMatch"
                autoComplete="current-password"
                inputRef={register({ validate: value => value === password || "Las contraseñas no coinciden" })}
              />
              <FormHelperText error={true} className={classes.formHelperText}>
                {errors?.passwordMatch && errors.passwordMatch.message}
              </FormHelperText>
              <FormControl margin="normal" fullWidth>
                <Button
                  className={classes.button}
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="secondary">
                  Registrarme
                </Button>
              </FormControl>
              <Box marginTop={3}>
                <Typography className={classes.link} noWrap>
                  <RouterLink to="/login">Ya tengo usuario</RouterLink>
                </Typography>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default UserRegisterForm;